// source: grpc-models/BusinessOnboarding.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.AddBusinessOnboardingDetailsRequest', null, global);
goog.exportSymbol('proto.AddBusinessOnboardingDetailsResponse', null, global);
goog.exportSymbol('proto.AddBusinessOnboardingDetailsTempRequest', null, global);
goog.exportSymbol('proto.AddBusinessOnboardingDetailsTempResponse', null, global);
goog.exportSymbol('proto.BrandColorModel', null, global);
goog.exportSymbol('proto.BusinessOnboardingDetails', null, global);
goog.exportSymbol('proto.GetBusinessOnboardingDetailsRequest', null, global);
goog.exportSymbol('proto.GetBusinessOnboardingDetailsResponse', null, global);
goog.exportSymbol('proto.GetBusinessSegmentRequest', null, global);
goog.exportSymbol('proto.GetBusinessSegmentResponse', null, global);
goog.exportSymbol('proto.ScrapeBusinessOnboardingDetailsRequest', null, global);
goog.exportSymbol('proto.ScrapeBusinessOnboardingDetailsResponse', null, global);
goog.exportSymbol('proto.ScrapedProductPreview', null, global);
goog.exportSymbol('proto.SkipScrapingRequest', null, global);
goog.exportSymbol('proto.UpdateBusinessOnboardingCompletionStatusRequest', null, global);
goog.exportSymbol('proto.UpdateBusinessOnboardingCompletionStatusResponse', null, global);
goog.exportSymbol('proto.UpdateBusinessOnboardingDetailsRequest', null, global);
goog.exportSymbol('proto.UpdateBusinessOnboardingDetailsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetBusinessOnboardingDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetBusinessOnboardingDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetBusinessOnboardingDetailsRequest.displayName = 'proto.GetBusinessOnboardingDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetBusinessSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetBusinessSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetBusinessSegmentRequest.displayName = 'proto.GetBusinessSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetBusinessSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetBusinessSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetBusinessSegmentResponse.displayName = 'proto.GetBusinessSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetBusinessOnboardingDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GetBusinessOnboardingDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.GetBusinessOnboardingDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetBusinessOnboardingDetailsResponse.displayName = 'proto.GetBusinessOnboardingDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AddBusinessOnboardingDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AddBusinessOnboardingDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AddBusinessOnboardingDetailsRequest.displayName = 'proto.AddBusinessOnboardingDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AddBusinessOnboardingDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AddBusinessOnboardingDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AddBusinessOnboardingDetailsResponse.displayName = 'proto.AddBusinessOnboardingDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AddBusinessOnboardingDetailsTempRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AddBusinessOnboardingDetailsTempRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AddBusinessOnboardingDetailsTempRequest.displayName = 'proto.AddBusinessOnboardingDetailsTempRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AddBusinessOnboardingDetailsTempResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AddBusinessOnboardingDetailsTempResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AddBusinessOnboardingDetailsTempResponse.displayName = 'proto.AddBusinessOnboardingDetailsTempResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateBusinessOnboardingDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateBusinessOnboardingDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateBusinessOnboardingDetailsRequest.displayName = 'proto.UpdateBusinessOnboardingDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateBusinessOnboardingDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateBusinessOnboardingDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateBusinessOnboardingDetailsResponse.displayName = 'proto.UpdateBusinessOnboardingDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateBusinessOnboardingCompletionStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateBusinessOnboardingCompletionStatusRequest.displayName = 'proto.UpdateBusinessOnboardingCompletionStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateBusinessOnboardingCompletionStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateBusinessOnboardingCompletionStatusResponse.displayName = 'proto.UpdateBusinessOnboardingCompletionStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ScrapeBusinessOnboardingDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ScrapeBusinessOnboardingDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ScrapeBusinessOnboardingDetailsRequest.displayName = 'proto.ScrapeBusinessOnboardingDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ScrapeBusinessOnboardingDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ScrapeBusinessOnboardingDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.ScrapeBusinessOnboardingDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ScrapeBusinessOnboardingDetailsResponse.displayName = 'proto.ScrapeBusinessOnboardingDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ScrapedProductPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ScrapedProductPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ScrapedProductPreview.displayName = 'proto.ScrapedProductPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SkipScrapingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SkipScrapingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SkipScrapingRequest.displayName = 'proto.SkipScrapingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BusinessOnboardingDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.BusinessOnboardingDetails.repeatedFields_, null);
};
goog.inherits(proto.BusinessOnboardingDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.BusinessOnboardingDetails.displayName = 'proto.BusinessOnboardingDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BrandColorModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.BrandColorModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.BrandColorModel.displayName = 'proto.BrandColorModel';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetBusinessOnboardingDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetBusinessOnboardingDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetBusinessOnboardingDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessOnboardingDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetBusinessOnboardingDetailsRequest}
 */
proto.GetBusinessOnboardingDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetBusinessOnboardingDetailsRequest;
  return proto.GetBusinessOnboardingDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetBusinessOnboardingDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetBusinessOnboardingDetailsRequest}
 */
proto.GetBusinessOnboardingDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetBusinessOnboardingDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetBusinessOnboardingDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetBusinessOnboardingDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessOnboardingDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 businessId = 1;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsRequest} returns this
 */
proto.GetBusinessOnboardingDetailsRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetBusinessSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetBusinessSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetBusinessSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetBusinessSegmentRequest}
 */
proto.GetBusinessSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetBusinessSegmentRequest;
  return proto.GetBusinessSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetBusinessSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetBusinessSegmentRequest}
 */
proto.GetBusinessSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetBusinessSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetBusinessSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetBusinessSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 businessId = 1;
 * @return {number}
 */
proto.GetBusinessSegmentRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessSegmentRequest} returns this
 */
proto.GetBusinessSegmentRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetBusinessSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetBusinessSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetBusinessSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    segment: jspb.Message.getFieldWithDefault(msg, 1, ""),
    businesscategoryid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetBusinessSegmentResponse}
 */
proto.GetBusinessSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetBusinessSegmentResponse;
  return proto.GetBusinessSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetBusinessSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetBusinessSegmentResponse}
 */
proto.GetBusinessSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegment(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesscategoryid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetBusinessSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetBusinessSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetBusinessSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegment();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBusinesscategoryid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string segment = 1;
 * @return {string}
 */
proto.GetBusinessSegmentResponse.prototype.getSegment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetBusinessSegmentResponse} returns this
 */
proto.GetBusinessSegmentResponse.prototype.setSegment = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 businessCategoryId = 2;
 * @return {number}
 */
proto.GetBusinessSegmentResponse.prototype.getBusinesscategoryid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessSegmentResponse} returns this
 */
proto.GetBusinessSegmentResponse.prototype.setBusinesscategoryid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GetBusinessOnboardingDetailsResponse.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetBusinessOnboardingDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetBusinessOnboardingDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessOnboardingDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    businesscategoryid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pricetierid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    businessusp: (f = msg.getBusinessusp()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesscategoryname: (f = msg.getBusinesscategoryname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isonboardingcompleted: (f = msg.getIsonboardingcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    websiteurl: (f = msg.getWebsiteurl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businessname: (f = msg.getBusinessname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesstypeid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    phonenumber: (f = msg.getPhonenumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address: (f = msg.getAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    scraperdjson: jspb.Message.getFieldWithDefault(msg, 14, ""),
    isscrapingcompleted: (f = msg.getIsscrapingcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    brandcolorsList: jspb.Message.toObjectList(msg.getBrandcolorsList(),
    proto.BrandColorModel.toObject, includeInstance),
    businessLogoUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
    businesstoneid: jspb.Message.getFieldWithDefault(msg, 18, 0),
    businesstypefaceid: jspb.Message.getFieldWithDefault(msg, 19, 0),
    segment: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetBusinessOnboardingDetailsResponse}
 */
proto.GetBusinessOnboardingDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetBusinessOnboardingDetailsResponse;
  return proto.GetBusinessOnboardingDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetBusinessOnboardingDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetBusinessOnboardingDetailsResponse}
 */
proto.GetBusinessOnboardingDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesscategoryid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPricetierid(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessusp(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinesscategoryname(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsonboardingcompleted(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setWebsiteurl(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessname(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstypeid(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhonenumber(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setScraperdjson(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsscrapingcompleted(value);
      break;
    case 16:
      var value = new proto.BrandColorModel;
      reader.readMessage(value,proto.BrandColorModel.deserializeBinaryFromReader);
      msg.addBrandcolors(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessLogoUrl(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstoneid(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstypefaceid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetBusinessOnboardingDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetBusinessOnboardingDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetBusinessOnboardingDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getBusinesscategoryid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPricetierid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBusinessusp();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesscategoryname();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingcompleted();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getWebsiteurl();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinessname();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesstypeid();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPhonenumber();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getScraperdjson();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsscrapingcompleted();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandcolorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.BrandColorModel.serializeBinaryToWriter
    );
  }
  f = message.getBusinessLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getBusinesstoneid();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getBusinesstypefaceid();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getSegment();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 businessCategoryId = 2;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinesscategoryid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinesscategoryid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 priceTierId = 3;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getPricetierid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setPricetierid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue businessUsp = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinessusp = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinessusp = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearBusinessusp = function() {
  return this.setBusinessusp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasBusinessusp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue businessCategoryName = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinesscategoryname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinesscategoryname = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearBusinesscategoryname = function() {
  return this.setBusinesscategoryname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasBusinesscategoryname = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue isOnboardingCompleted = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getIsonboardingcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setIsonboardingcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearIsonboardingcompleted = function() {
  return this.setIsonboardingcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasIsonboardingcompleted = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue websiteUrl = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getWebsiteurl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setWebsiteurl = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearWebsiteurl = function() {
  return this.setWebsiteurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasWebsiteurl = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue businessName = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinessname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinessname = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearBusinessname = function() {
  return this.setBusinessname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasBusinessname = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 businessTypeId = 9;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinesstypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinesstypeid = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue phoneNumber = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getPhonenumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setPhonenumber = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearPhonenumber = function() {
  return this.setPhonenumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasPhonenumber = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue address = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue city = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasCity = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue state = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasState = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string scraperdJson = 14;
 * @return {string}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getScraperdjson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setScraperdjson = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.BoolValue isScrapingCompleted = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getIsscrapingcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setIsscrapingcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearIsscrapingcompleted = function() {
  return this.setIsscrapingcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.hasIsscrapingcompleted = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated BrandColorModel brandColors = 16;
 * @return {!Array<!proto.BrandColorModel>}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBrandcolorsList = function() {
  return /** @type{!Array<!proto.BrandColorModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.BrandColorModel, 16));
};


/**
 * @param {!Array<!proto.BrandColorModel>} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.GetBusinessOnboardingDetailsResponse.prototype.setBrandcolorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.BrandColorModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.BrandColorModel}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.addBrandcolors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.BrandColorModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.clearBrandcolorsList = function() {
  return this.setBrandcolorsList([]);
};


/**
 * optional string business_logo_url = 17;
 * @return {string}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinessLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinessLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int32 businessToneId = 18;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinesstoneid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinesstoneid = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 businessTypefaceId = 19;
 * @return {number}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getBusinesstypefaceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setBusinesstypefaceid = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string segment = 20;
 * @return {string}
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.getSegment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.GetBusinessOnboardingDetailsResponse.prototype.setSegment = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AddBusinessOnboardingDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.AddBusinessOnboardingDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AddBusinessOnboardingDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessonboardingdetails: (f = msg.getBusinessonboardingdetails()) && proto.BusinessOnboardingDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AddBusinessOnboardingDetailsRequest}
 */
proto.AddBusinessOnboardingDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AddBusinessOnboardingDetailsRequest;
  return proto.AddBusinessOnboardingDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AddBusinessOnboardingDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AddBusinessOnboardingDetailsRequest}
 */
proto.AddBusinessOnboardingDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.BusinessOnboardingDetails;
      reader.readMessage(value,proto.BusinessOnboardingDetails.deserializeBinaryFromReader);
      msg.setBusinessonboardingdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AddBusinessOnboardingDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AddBusinessOnboardingDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AddBusinessOnboardingDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessonboardingdetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.BusinessOnboardingDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional BusinessOnboardingDetails businessOnboardingDetails = 1;
 * @return {?proto.BusinessOnboardingDetails}
 */
proto.AddBusinessOnboardingDetailsRequest.prototype.getBusinessonboardingdetails = function() {
  return /** @type{?proto.BusinessOnboardingDetails} */ (
    jspb.Message.getWrapperField(this, proto.BusinessOnboardingDetails, 1));
};


/**
 * @param {?proto.BusinessOnboardingDetails|undefined} value
 * @return {!proto.AddBusinessOnboardingDetailsRequest} returns this
*/
proto.AddBusinessOnboardingDetailsRequest.prototype.setBusinessonboardingdetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AddBusinessOnboardingDetailsRequest} returns this
 */
proto.AddBusinessOnboardingDetailsRequest.prototype.clearBusinessonboardingdetails = function() {
  return this.setBusinessonboardingdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsRequest.prototype.hasBusinessonboardingdetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.AddBusinessOnboardingDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AddBusinessOnboardingDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: (f = msg.getMessage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AddBusinessOnboardingDetailsResponse}
 */
proto.AddBusinessOnboardingDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AddBusinessOnboardingDetailsResponse;
  return proto.AddBusinessOnboardingDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AddBusinessOnboardingDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AddBusinessOnboardingDetailsResponse}
 */
proto.AddBusinessOnboardingDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AddBusinessOnboardingDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AddBusinessOnboardingDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AddBusinessOnboardingDetailsResponse} returns this
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue message = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.AddBusinessOnboardingDetailsResponse} returns this
*/
proto.AddBusinessOnboardingDetailsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AddBusinessOnboardingDetailsResponse} returns this
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.AddBusinessOnboardingDetailsTempRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AddBusinessOnboardingDetailsTempRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsTempRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessonboardingdetails: (f = msg.getBusinessonboardingdetails()) && proto.BusinessOnboardingDetails.toObject(includeInstance, f),
    isreferraluser: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    referralcode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest}
 */
proto.AddBusinessOnboardingDetailsTempRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AddBusinessOnboardingDetailsTempRequest;
  return proto.AddBusinessOnboardingDetailsTempRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AddBusinessOnboardingDetailsTempRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest}
 */
proto.AddBusinessOnboardingDetailsTempRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.BusinessOnboardingDetails;
      reader.readMessage(value,proto.BusinessOnboardingDetails.deserializeBinaryFromReader);
      msg.setBusinessonboardingdetails(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsreferraluser(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferralcode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AddBusinessOnboardingDetailsTempRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AddBusinessOnboardingDetailsTempRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsTempRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessonboardingdetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.BusinessOnboardingDetails.serializeBinaryToWriter
    );
  }
  f = message.getIsreferraluser();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getReferralcode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional BusinessOnboardingDetails businessOnboardingDetails = 1;
 * @return {?proto.BusinessOnboardingDetails}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.getBusinessonboardingdetails = function() {
  return /** @type{?proto.BusinessOnboardingDetails} */ (
    jspb.Message.getWrapperField(this, proto.BusinessOnboardingDetails, 1));
};


/**
 * @param {?proto.BusinessOnboardingDetails|undefined} value
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
*/
proto.AddBusinessOnboardingDetailsTempRequest.prototype.setBusinessonboardingdetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.clearBusinessonboardingdetails = function() {
  return this.setBusinessonboardingdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.hasBusinessonboardingdetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool isReferralUser = 2;
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.getIsreferraluser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.setIsreferraluser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string referralCode = 3;
 * @return {string}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.getReferralcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.setReferralcode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string timezone = 4;
 * @return {string}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.AddBusinessOnboardingDetailsTempRequest} returns this
 */
proto.AddBusinessOnboardingDetailsTempRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.AddBusinessOnboardingDetailsTempResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AddBusinessOnboardingDetailsTempResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsTempResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: (f = msg.getMessage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    token: (f = msg.getToken()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businessid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse}
 */
proto.AddBusinessOnboardingDetailsTempResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AddBusinessOnboardingDetailsTempResponse;
  return proto.AddBusinessOnboardingDetailsTempResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AddBusinessOnboardingDetailsTempResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse}
 */
proto.AddBusinessOnboardingDetailsTempResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AddBusinessOnboardingDetailsTempResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AddBusinessOnboardingDetailsTempResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AddBusinessOnboardingDetailsTempResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue message = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
*/
proto.AddBusinessOnboardingDetailsTempResponse.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue token = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.getToken = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
*/
proto.AddBusinessOnboardingDetailsTempResponse.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.hasToken = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 businessId = 4;
 * @return {number}
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.AddBusinessOnboardingDetailsTempResponse} returns this
 */
proto.AddBusinessOnboardingDetailsTempResponse.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateBusinessOnboardingDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateBusinessOnboardingDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    businessid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessonboardingdetails: (f = msg.getBusinessonboardingdetails()) && proto.BusinessOnboardingDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest}
 */
proto.UpdateBusinessOnboardingDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateBusinessOnboardingDetailsRequest;
  return proto.UpdateBusinessOnboardingDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateBusinessOnboardingDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest}
 */
proto.UpdateBusinessOnboardingDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    case 3:
      var value = new proto.BusinessOnboardingDetails;
      reader.readMessage(value,proto.BusinessOnboardingDetails.deserializeBinaryFromReader);
      msg.setBusinessonboardingdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateBusinessOnboardingDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateBusinessOnboardingDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBusinessonboardingdetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.BusinessOnboardingDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest} returns this
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 businessId = 2;
 * @return {number}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest} returns this
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional BusinessOnboardingDetails businessOnboardingDetails = 3;
 * @return {?proto.BusinessOnboardingDetails}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.getBusinessonboardingdetails = function() {
  return /** @type{?proto.BusinessOnboardingDetails} */ (
    jspb.Message.getWrapperField(this, proto.BusinessOnboardingDetails, 3));
};


/**
 * @param {?proto.BusinessOnboardingDetails|undefined} value
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest} returns this
*/
proto.UpdateBusinessOnboardingDetailsRequest.prototype.setBusinessonboardingdetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UpdateBusinessOnboardingDetailsRequest} returns this
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.clearBusinessonboardingdetails = function() {
  return this.setBusinessonboardingdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingDetailsRequest.prototype.hasBusinessonboardingdetails = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateBusinessOnboardingDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateBusinessOnboardingDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: (f = msg.getMessage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateBusinessOnboardingDetailsResponse}
 */
proto.UpdateBusinessOnboardingDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateBusinessOnboardingDetailsResponse;
  return proto.UpdateBusinessOnboardingDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateBusinessOnboardingDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateBusinessOnboardingDetailsResponse}
 */
proto.UpdateBusinessOnboardingDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateBusinessOnboardingDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateBusinessOnboardingDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.UpdateBusinessOnboardingDetailsResponse} returns this
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue message = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.UpdateBusinessOnboardingDetailsResponse} returns this
*/
proto.UpdateBusinessOnboardingDetailsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UpdateBusinessOnboardingDetailsResponse} returns this
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingDetailsResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateBusinessOnboardingCompletionStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    isonboardingcompleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusRequest}
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateBusinessOnboardingCompletionStatusRequest;
  return proto.UpdateBusinessOnboardingCompletionStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusRequest}
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsonboardingcompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateBusinessOnboardingCompletionStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsonboardingcompleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool isOnboardingCompleted = 1;
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.prototype.getIsonboardingcompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusRequest} returns this
 */
proto.UpdateBusinessOnboardingCompletionStatusRequest.prototype.setIsonboardingcompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateBusinessOnboardingCompletionStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: (f = msg.getMessage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusResponse}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateBusinessOnboardingCompletionStatusResponse;
  return proto.UpdateBusinessOnboardingCompletionStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusResponse}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateBusinessOnboardingCompletionStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateBusinessOnboardingCompletionStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusResponse} returns this
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue message = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusResponse} returns this
*/
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UpdateBusinessOnboardingCompletionStatusResponse} returns this
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UpdateBusinessOnboardingCompletionStatusResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ScrapeBusinessOnboardingDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ScrapeBusinessOnboardingDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapeBusinessOnboardingDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    websiteurl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    businessid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ScrapeBusinessOnboardingDetailsRequest}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ScrapeBusinessOnboardingDetailsRequest;
  return proto.ScrapeBusinessOnboardingDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ScrapeBusinessOnboardingDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ScrapeBusinessOnboardingDetailsRequest}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteurl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ScrapeBusinessOnboardingDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ScrapeBusinessOnboardingDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapeBusinessOnboardingDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebsiteurl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string websiteUrl = 1;
 * @return {string}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.getWebsiteurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsRequest} returns this
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.setWebsiteurl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 businessId = 2;
 * @return {number}
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsRequest} returns this
 */
proto.ScrapeBusinessOnboardingDetailsRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ScrapeBusinessOnboardingDetailsResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ScrapeBusinessOnboardingDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ScrapeBusinessOnboardingDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapeBusinessOnboardingDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessonboardingdetails: (f = msg.getBusinessonboardingdetails()) && proto.BusinessOnboardingDetails.toObject(includeInstance, f),
    previewproductsList: jspb.Message.toObjectList(msg.getPreviewproductsList(),
    proto.ScrapedProductPreview.toObject, includeInstance),
    businessscrapems: jspb.Message.getFieldWithDefault(msg, 5, 0),
    previewproductsms: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ScrapeBusinessOnboardingDetailsResponse;
  return proto.ScrapeBusinessOnboardingDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ScrapeBusinessOnboardingDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.BusinessOnboardingDetails;
      reader.readMessage(value,proto.BusinessOnboardingDetails.deserializeBinaryFromReader);
      msg.setBusinessonboardingdetails(value);
      break;
    case 4:
      var value = new proto.ScrapedProductPreview;
      reader.readMessage(value,proto.ScrapedProductPreview.deserializeBinaryFromReader);
      msg.addPreviewproducts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessscrapems(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPreviewproductsms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ScrapeBusinessOnboardingDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ScrapeBusinessOnboardingDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapeBusinessOnboardingDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBusinessonboardingdetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.BusinessOnboardingDetails.serializeBinaryToWriter
    );
  }
  f = message.getPreviewproductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.ScrapedProductPreview.serializeBinaryToWriter
    );
  }
  f = message.getBusinessscrapems();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPreviewproductsms();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional BusinessOnboardingDetails businessOnboardingDetails = 3;
 * @return {?proto.BusinessOnboardingDetails}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getBusinessonboardingdetails = function() {
  return /** @type{?proto.BusinessOnboardingDetails} */ (
    jspb.Message.getWrapperField(this, proto.BusinessOnboardingDetails, 3));
};


/**
 * @param {?proto.BusinessOnboardingDetails|undefined} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
*/
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setBusinessonboardingdetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.clearBusinessonboardingdetails = function() {
  return this.setBusinessonboardingdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.hasBusinessonboardingdetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ScrapedProductPreview previewProducts = 4;
 * @return {!Array<!proto.ScrapedProductPreview>}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getPreviewproductsList = function() {
  return /** @type{!Array<!proto.ScrapedProductPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ScrapedProductPreview, 4));
};


/**
 * @param {!Array<!proto.ScrapedProductPreview>} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
*/
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setPreviewproductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.ScrapedProductPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ScrapedProductPreview}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.addPreviewproducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.ScrapedProductPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.clearPreviewproductsList = function() {
  return this.setPreviewproductsList([]);
};


/**
 * optional int64 businessScrapeMs = 5;
 * @return {number}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getBusinessscrapems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setBusinessscrapems = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 previewProductsMs = 6;
 * @return {number}
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.getPreviewproductsms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ScrapeBusinessOnboardingDetailsResponse} returns this
 */
proto.ScrapeBusinessOnboardingDetailsResponse.prototype.setPreviewproductsms = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ScrapedProductPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.ScrapedProductPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ScrapedProductPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapedProductPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
    price: jspb.Message.getFieldWithDefault(msg, 3, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    producturl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    heroimage: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    category: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ScrapedProductPreview}
 */
proto.ScrapedProductPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ScrapedProductPreview;
  return proto.ScrapedProductPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ScrapedProductPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ScrapedProductPreview}
 */
proto.ScrapedProductPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProducturl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeroimage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ScrapedProductPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ScrapedProductPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ScrapedProductPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ScrapedProductPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProducturl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHeroimage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string price = 3;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string productUrl = 5;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getProducturl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setProducturl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string heroImage = 6;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getHeroimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setHeroimage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string category = 8;
 * @return {string}
 */
proto.ScrapedProductPreview.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.ScrapedProductPreview} returns this
 */
proto.ScrapedProductPreview.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SkipScrapingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SkipScrapingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SkipScrapingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SkipScrapingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SkipScrapingRequest}
 */
proto.SkipScrapingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SkipScrapingRequest;
  return proto.SkipScrapingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SkipScrapingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SkipScrapingRequest}
 */
proto.SkipScrapingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SkipScrapingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SkipScrapingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SkipScrapingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SkipScrapingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.BusinessOnboardingDetails.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.BusinessOnboardingDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.BusinessOnboardingDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BusinessOnboardingDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BusinessOnboardingDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    businesscategoryid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pricetierid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessusp: (f = msg.getBusinessusp()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    custombusinesscategory: (f = msg.getCustombusinesscategory()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isonboardingcompleted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    websiteurl: (f = msg.getWebsiteurl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businessname: (f = msg.getBusinessname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phonenumber: (f = msg.getPhonenumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address: (f = msg.getAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesstypeid: jspb.Message.getFieldWithDefault(msg, 12, 0),
    scraperdjson: (f = msg.getScraperdjson()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    brandcolorsList: jspb.Message.toObjectList(msg.getBrandcolorsList(),
    proto.BrandColorModel.toObject, includeInstance),
    businessLogoUrl: (f = msg.getBusinessLogoUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesstoneid: jspb.Message.getFieldWithDefault(msg, 16, 0),
    businesstypefaceid: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BusinessOnboardingDetails}
 */
proto.BusinessOnboardingDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BusinessOnboardingDetails;
  return proto.BusinessOnboardingDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BusinessOnboardingDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BusinessOnboardingDetails}
 */
proto.BusinessOnboardingDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesscategoryid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPricetierid(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessusp(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustombusinesscategory(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsonboardingcompleted(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setWebsiteurl(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessname(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhonenumber(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstypeid(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setScraperdjson(value);
      break;
    case 14:
      var value = new proto.BrandColorModel;
      reader.readMessage(value,proto.BrandColorModel.deserializeBinaryFromReader);
      msg.addBrandcolors(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessLogoUrl(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstoneid(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstypefaceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BusinessOnboardingDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.BusinessOnboardingDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BusinessOnboardingDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BusinessOnboardingDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinesscategoryid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPricetierid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBusinessusp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustombusinesscategory();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingcompleted();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getWebsiteurl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinessname();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhonenumber();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesstypeid();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getScraperdjson();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandcolorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.BrandColorModel.serializeBinaryToWriter
    );
  }
  f = message.getBusinessLogoUrl();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesstoneid();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getBusinesstypefaceid();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * optional int32 businessCategoryId = 1;
 * @return {number}
 */
proto.BusinessOnboardingDetails.prototype.getBusinesscategoryid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setBusinesscategoryid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 priceTierId = 2;
 * @return {number}
 */
proto.BusinessOnboardingDetails.prototype.getPricetierid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setPricetierid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue businessUsp = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getBusinessusp = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setBusinessusp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearBusinessusp = function() {
  return this.setBusinessusp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasBusinessusp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue customBusinessCategory = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getCustombusinesscategory = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setCustombusinesscategory = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearCustombusinesscategory = function() {
  return this.setCustombusinesscategory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasCustombusinesscategory = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool isOnboardingCompleted = 5;
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.getIsonboardingcompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setIsonboardingcompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue websiteUrl = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getWebsiteurl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setWebsiteurl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearWebsiteurl = function() {
  return this.setWebsiteurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasWebsiteurl = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue businessName = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getBusinessname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setBusinessname = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearBusinessname = function() {
  return this.setBusinessname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasBusinessname = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue phoneNumber = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getPhonenumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setPhonenumber = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearPhonenumber = function() {
  return this.setPhonenumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasPhonenumber = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue address = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue city = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasCity = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue state = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasState = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 businessTypeId = 12;
 * @return {number}
 */
proto.BusinessOnboardingDetails.prototype.getBusinesstypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setBusinesstypeid = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional google.protobuf.StringValue scraperdJson = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getScraperdjson = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setScraperdjson = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearScraperdjson = function() {
  return this.setScraperdjson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasScraperdjson = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated BrandColorModel brandColors = 14;
 * @return {!Array<!proto.BrandColorModel>}
 */
proto.BusinessOnboardingDetails.prototype.getBrandcolorsList = function() {
  return /** @type{!Array<!proto.BrandColorModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.BrandColorModel, 14));
};


/**
 * @param {!Array<!proto.BrandColorModel>} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setBrandcolorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.BrandColorModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.BrandColorModel}
 */
proto.BusinessOnboardingDetails.prototype.addBrandcolors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.BrandColorModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearBrandcolorsList = function() {
  return this.setBrandcolorsList([]);
};


/**
 * optional google.protobuf.StringValue business_logo_url = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.BusinessOnboardingDetails.prototype.getBusinessLogoUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.BusinessOnboardingDetails} returns this
*/
proto.BusinessOnboardingDetails.prototype.setBusinessLogoUrl = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.clearBusinessLogoUrl = function() {
  return this.setBusinessLogoUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.BusinessOnboardingDetails.prototype.hasBusinessLogoUrl = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional int32 businessToneId = 16;
 * @return {number}
 */
proto.BusinessOnboardingDetails.prototype.getBusinesstoneid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setBusinesstoneid = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 businessTypefaceId = 17;
 * @return {number}
 */
proto.BusinessOnboardingDetails.prototype.getBusinesstypefaceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.BusinessOnboardingDetails} returns this
 */
proto.BusinessOnboardingDetails.prototype.setBusinesstypefaceid = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.BrandColorModel.prototype.toObject = function(opt_includeInstance) {
  return proto.BrandColorModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BrandColorModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BrandColorModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
    color: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isscrapped: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BrandColorModel}
 */
proto.BrandColorModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BrandColorModel;
  return proto.BrandColorModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BrandColorModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BrandColorModel}
 */
proto.BrandColorModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsscrapped(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BrandColorModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.BrandColorModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BrandColorModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BrandColorModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsscrapped();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.BrandColorModel.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.BrandColorModel} returns this
 */
proto.BrandColorModel.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string color = 2;
 * @return {string}
 */
proto.BrandColorModel.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.BrandColorModel} returns this
 */
proto.BrandColorModel.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isScrapped = 3;
 * @return {boolean}
 */
proto.BrandColorModel.prototype.getIsscrapped = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.BrandColorModel} returns this
 */
proto.BrandColorModel.prototype.setIsscrapped = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


goog.object.extend(exports, proto);
